
//  console.log("Development Build")

console.log("Development Build")

// export const environment = {
//     production: false,
//     userApiUrl: 'https://creduserapi.wearedev.team/',
//     walletApiUrl: 'https://credwalletapi.wearedev.team/',
//     spotApiUrl: 'https://credspotapi.wearedev.team/',
//     launchpadApiUrl: 'https://credlaunchpadapi.wearedev.team/',
//     botApiUrl: 'https://credbotapi.wearedev.team/'
// };

// export const environment = {
//     production: true,
//     userApiUrl: 'https://userapi.credbull.in/',
//     walletApiUrl: 'https://walletapi.credbull.in/',
//     spotApiUrl: 'https://spotapi.credbull.in/',
//     launchpadApiUrl: 'https://launchpadapi.credbull.in/',
//     botApiUrl: 'https://botapi.credbull.in/'
// };

export const environment = {
    production: false,
    userApiUrl: 'http://localhost:3001/',
    walletApiUrl: 'http://localhost:3002/',
    spotApiUrl: 'http://localhost:3003/',
    launchpadApiUrl: 'http://localhost:3006/',
    botApiUrl: 'http://localhost:3007/',
    gridBotApiUrl: 'http://localhost:3008/',
    arbitrageBotApiUrl: 'http://localhost:3040/',
    adminTradebotApiUrl: 'http://localhost:3009/',
    adminTradebotDownSideApiUrl: 'http://localhost:3010/',
    hanumanUpsideApiUrl: 'http://localhost:3011/',
    guruBotApiUrl: 'http://localhost:3012/',
};
